import React from "react";

export const RPGGameClanSkinsIcon = () => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.51608L10.9043 6.54628L10.9382 9.99536H8.53059L8.43098 6.52421L9.50975 6.51608L9.03461 3.68018L7.27849 2.60365L8.13514 2.11706C8.22877 1.58634 8.61725 1.35989 8.61725 1.02892C8.61725 0.564394 7.96381 0.564395 7.96381 1.18337L7.54545 1.06724C7.59326 0.409941 7.79248 0 8.45887 0C8.99875 0 9.25575 0.348392 9.25575 1.00105C9.25575 1.53641 8.91508 1.72454 8.85731 2.12054L11.5249 3.67785L12 6.51608ZM5.89192 10H1.16544V6.67867L0 6.71118L0.448244 3.65579L3.15464 2.11706C3.24828 1.58634 3.63676 1.35989 3.63676 1.02892C3.63676 0.564394 2.98332 0.564395 2.98332 1.18337L2.56495 1.06724C2.61277 0.409941 2.81199 0 3.47838 0C4.01826 0 4.27526 0.348392 4.27526 1.00105C4.27526 1.53641 3.93459 1.72454 3.87682 2.12054L6.54437 3.68018L7.01951 6.51608L5.90686 6.54628L5.89192 10ZM5.6429 2.12519C5.73454 1.58867 6.127 1.36105 6.127 1.02892C6.127 0.564394 5.47356 0.564395 5.47356 1.18337L5.0552 1.06724C5.10301 0.409941 5.30223 0 5.96862 0C6.50851 0 6.7655 0.348392 6.7655 1.00105C6.7655 1.57125 6.38001 1.74776 6.35611 2.19951L5.6429 2.12519Z"
      />
    </svg>
  );
};
